import {
  useEffect,
  useState,
} from "react";
import {
  apiRequest,
} from "../../shared/api/client";

export type SettingsModuleProps = {
  notify: (message: string) => void;
  dataRefreshVersion: number;
};

export function useSettingsWorkspace({
  notify,
  dataRefreshVersion,
}: SettingsModuleProps) {
  const [settings, setSettings] = useState({
    currency: "TRY",
    deadlineReminder: true,
    revisionReminder: true,
  });
  const [scoringProfile, setScoringProfile] = useState({
    version: 1,
    weights: { amount: 55, delivery: 25, payment: 20 },
  });
  useEffect(() => {
    Promise.all([
      apiRequest<typeof settings>("/api/settings"),
      apiRequest<typeof scoringProfile>("/api/scoring-profile"),
    ])
      .then(([savedSettings, profile]) => {
        setSettings(savedSettings);
        setScoringProfile(profile);
      })
      .catch(() => notify("Ayarlar sunucudan alınamadı."));
  }, [dataRefreshVersion, notify]);
  const saveSettings = async () => {
    try {
      const weightTotal = Object.values(scoringProfile.weights).reduce(
        (sum, value) => sum + value,
        0,
      );
      if (weightTotal !== 100) {
        notify("Kriter ağırlıklarının toplamı %100 olmalıdır.");
        return;
      }
      const [saved, savedProfile] = await Promise.all([
        apiRequest<typeof settings>("/api/settings", {
          method: "PUT",
          body: JSON.stringify(settings),
        }),
        apiRequest<typeof scoringProfile>("/api/scoring-profile", {
          method: "PUT",
          body: JSON.stringify(scoringProfile.weights),
        }),
      ]);
      setSettings(saved);
      setScoringProfile(savedProfile);
      notify(
        `Ayarlar kaydedildi. Puanlama profili sürüm ${savedProfile.version} yeni değerlendirmelerde kullanılacak.`,
      );
    } catch (error) {
      notify(error instanceof Error ? error.message : "Ayarlar kaydedilemedi.");
    }
  };
  return {
    notify,
    dataRefreshVersion,
    settings,
    setSettings,
    scoringProfile,
    setScoringProfile,
    saveSettings,
  };
}
